<div>
  <ag-tooltip-v2 *ngFor="let tooltip of tooltipService.componentsV2" [ref]="tooltip.ref" [title]="tooltip.title" [description]="tooltip.description" [position]="tooltip.position" [adjustPosition]="tooltip.adjustPosition"></ag-tooltip-v2>
</div>
